import { supabase } from '../config/supabase';

// Cache session promise to avoid race conditions when multiple parallel requests
// are made. This ensures all concurrent fetchWithAuth calls share the same session fetch.
let sessionPromise = null;
let sessionCacheTime = 0;
const SESSION_CACHE_TTL = 5000; // 5 seconds cache TTL

const getCachedSession = async () => {
  const now = Date.now();
  const cacheAge = now - sessionCacheTime;

  // If we have a cached promise and it's still valid, reuse it
  if (sessionPromise && cacheAge < SESSION_CACHE_TTL) {
    return sessionPromise;
  }

  // Check if supabase is available
  if (!supabase) {
    return null;
  }

  // Create a new session promise
  sessionCacheTime = now;
  sessionPromise = supabase.auth.getSession().then(({ data: { session } }) => {
    return session;
  }).catch((error) => {
    // Clear the cache on error so next call retries
    sessionPromise = null;
    console.error('Error getting session:', error);
    return null;
  });

  return sessionPromise;
};

export const fetchWithAuth = async (url, options = {}, providedSession = null) => {
  // Use provided session if available, otherwise fetch from cache
  const session = providedSession || await getCachedSession();

  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`;
  }

  return fetch(url, { ...options, headers });
};

// Export for testing purposes
export const clearSessionCache = () => {
  sessionPromise = null;
  sessionCacheTime = 0;
};
